import React, { Component } from "react";

export class Step6Project extends Component {
  constructor(props) {
    super(props);

    this.state = {
      projectType: props.formData.projectType || "",
      projectCategory: props.formData.projectCategory || "",
      sourceCode: props.formData.sourceCode || "Yes",
      blackBoundReport: props.formData.blackBoundReport || "Yes",
      vivaGuidance: props.formData.vivaGuidance || "Yes",
      resumeGuidance: props.formData.resumeGuidance || "Yes",
      placementSupport: props.formData.placementSupport || "No",
      additionalRequirement:
        props.formData.additionalRequirement || "",

      error: "",
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: "",
    });
  };

  handleNext = () => {
    const {
      projectType,
      projectCategory,
      sourceCode,
      blackBoundReport,
      vivaGuidance,
      resumeGuidance,
      placementSupport,
      additionalRequirement,
    } = this.state;

    if (!projectType || !projectCategory) {
      this.setState({
        error: "Please select Project Type and Project Category.",
      });
      return;
    }

    this.props.updateFormData({
      projectType,
      projectCategory,
      sourceCode,
      blackBoundReport,
      vivaGuidance,
      resumeGuidance,
      placementSupport,
      additionalRequirement,
    });

    this.props.nextStep();
  };

  render() {

    const packageDetails = this.props.formData.selectedPackage;

    return (
      <div className="container py-4">

  <div className="card shadow border-0">

    <div className="card-header bg-success text-white">
      <h3 className="mb-0">
        Step 6 : Project Requirements
      </h3>
    </div>

    <div className="card-body">

      <div className="row">

        {/* Project Type */}

        <div className="col-md-6 mb-3">

          <label className="form-label">
            Project Type *
          </label>

          <select
            className="form-select"
            name="projectType"
            value={this.state.projectType}
            onChange={this.handleChange}
          >
            <option value="">Select</option>
            <option>Live Project</option>
            <option>Ready-Made Project</option>
            <option>Both</option>
          </select>

        </div>

        {/* Project Category */}

        <div className="col-md-6 mb-3">

          <label className="form-label">
            Project Category *
          </label>

          <select
            className="form-select"
            name="projectCategory"
            value={this.state.projectCategory}
            onChange={this.handleChange}
          >
            <option value="">Select</option>
            <option>Website</option>
            <option>Mobile Application</option>
            <option>E-Commerce</option>
            <option>School ERP</option>
            <option>Hospital Management</option>
            <option>Inventory Management</option>
            <option>CRM</option>
            <option>HR Management</option>
            <option>Restaurant Management</option>
            <option>Custom Project</option>
          </select>

        </div>

        {/* Source Code */}

        <div className="col-md-6 mb-3">

          <label className="form-label">
            Source Code Required
          </label>

          <select
            className="form-select"
            name="sourceCode"
            value={this.state.sourceCode}
            onChange={this.handleChange}
          >
            <option>Yes</option>
            <option>No</option>
          </select>

        </div>

        {/* Black Bound Report */}

        <div className="col-md-6 mb-3">

          <label className="form-label">
            Black Bound Report
          </label>

          <select
            className="form-select"
            name="blackBoundReport"
            value={this.state.blackBoundReport}
            onChange={this.handleChange}
          >
            <option>Yes</option>
            <option>No</option>
          </select>

        </div>

        {/* Viva Guidance */}

        <div className="col-md-6 mb-3">

          <label className="form-label">
            Viva Guidance
          </label>

          <select
            className="form-select"
            name="vivaGuidance"
            value={this.state.vivaGuidance}
            onChange={this.handleChange}
          >
            <option>Yes</option>
            <option>No</option>
          </select>

        </div>

        {/* Resume Guidance */}

        <div className="col-md-6 mb-3">

          <label className="form-label">
            Resume Guidance
          </label>

          <select
            className="form-select"
            name="resumeGuidance"
            value={this.state.resumeGuidance}
            onChange={this.handleChange}
          >
            <option>Yes</option>
            <option>No</option>
          </select>

        </div>

        {/* Placement Assistance */}

        <div className="col-md-6 mb-3">

          <label className="form-label">
            Placement Assistance
          </label>

          <select
            className="form-select"
            name="placementSupport"
            value={this.state.placementSupport}
            onChange={this.handleChange}
          >
            <option>No</option>
            <option>Yes</option>
          </select>

        </div>

        {/* Additional Requirement */}

        <div className="col-12 mb-3">

          <label className="form-label">
            Additional Requirements
          </label>

          <textarea
            rows="5"
            className="form-control"
            name="additionalRequirement"
            placeholder="Write your project requirements..."
            value={this.state.additionalRequirement}
            onChange={this.handleChange}
          />

        </div>

      </div>
            {/* Internship Package Details */}

      {packageDetails && (

        <div className="alert alert-info mt-4">

          <div className="d-flex justify-content-between align-items-center mb-3">

            <h5 className="mb-0">
              {packageDetails.package_name}
            </h5>

            <span className="badge bg-success fs-6">
              ₹{Number(packageDetails.package_price).toLocaleString()}
            </span>

          </div>

          <p className="mb-2">
            <strong>Package Tag :</strong>{" "}
            {packageDetails.package_tag}
          </p>

          <hr />

          <strong>Internship Package Includes :</strong>

          <ul className="mt-3 mb-0">

            {Array.isArray(packageDetails.feature) &&
              packageDetails.feature.map((item) => (

                <li key={item.feature_id}>
                  {item.feature_name}
                </li>

              ))}

          </ul>

        </div>

      )}

      {this.state.error && (

        <div className="alert alert-danger">
          {this.state.error}
        </div>

      )}

      <hr />

      <div className="d-flex justify-content-between">

        <button
          className="btn btn-outline-secondary"
          onClick={this.props.prevStep}
        >
          Previous
        </button>

        <button
          className="btn btn-success"
          onClick={this.handleNext}
        >
          Review
        </button>

      </div>

    </div>

  </div>

</div>

    );
  }
}

export default Step6Project;